<template v-if="user">
  <div class="all-wrapper with-side-panel solid-bg-all">
     <div class="layout-w">
       <app-sidebar></app-sidebar>
       <div class="content-w">
         <app-navbar></app-navbar>
         <div class="content-i">
           <div class="content-box">
             <div class="alert alert-danger" role="alert">
               <b>Refund is not available on all payment types. All transactions made in zero1 are non-refundable.</b>
             </div>
             <div class="section-heading centered">
               <h1>
                 Premium Plan
               </h1>
             </div>
             <div class="pricing-plans row no-gutters">
               <div class="pricing-plan col-sm-4">
                 <div class="plan-head">
                   <div class="plan-image">
                     <img alt="" src="img/plan1.png">
                   </div>
                   <div class="plan-name">
                     Premium (Daily)
                   </div>
                 </div>
                 <div class="plan-body">
                   <div class="plan-price-w">
                     <div class="price-value" v-if="country === 'ID'">
                       Rp 4000
                     </div>
                     <div class="price-value" v-else>
                       US$ 2
                     </div>
                     <div class="price-label" v-if="country === 'ID'">
                       per hari
                     </div>
                     <div class="price-label" v-else>
                       per day
                     </div>
                   </div>
                   <div class="plan-btn-w" v-if="!this.$root.isAuthenticated">
                     <a class="btn btn-primary btn-rounded" href="https://api-staging.zero1.id/auth/steam">Login with Steam to Buy</a>&nbsp;
                   </div>
                   <div class="plan-btn-w" v-else>
                     <a class="btn btn-primary btn-rounded" href="#" @click="buyPremium('Premium', 'dana')">QR Payment</a>&nbsp;
                   </div>
                 </div>
                 <div class="plan-description">
                   <h6>
                     Features
                   </h6>
                   <ul>
                     <li>
                       Join full servers
                     </li>
                     <li>
                       <b>Access to !replace command (only on Retakes & DM servers)</b>
                     </li>
                     <li>
                       <b>2-rounds Arena Challenge cooldown</b>
                     </li>
                     <li>
                       <b>60-minutes Timelimit (only on Deathmatch servers)</b>
                     </li>
                   </ul>
                 </div>
               </div>
               <div class="pricing-plan col-sm-4">
                 <div class="plan-head">
                   <div class="plan-image">
                     <img alt="" src="img/plan2.png">
                   </div>
                   <div class="plan-name">
                     Premium+
                   </div>
                 </div>
                 <div class="plan-body">
                   <div class="plan-price-w">
                     <div class="price-value" v-if="country === 'ID'">
                       Rp 12rb
                     </div>
                     <div class="price-value" v-else>
                       US$ 4
                     </div>
                     <div class="price-label" v-if="country === 'ID'">
                       per minggu
                     </div>
                     <div class="price-label" v-else>
                       per week
                     </div>
                   </div>
                   <div class="plan-btn-w" v-if="!this.$root.isAuthenticated">
                     <a class="btn btn-primary btn-rounded" href="https://api-staging.zero1.id/auth/steam">Login with Steam to Buy</a>&nbsp;
                   </div>
                   <div class="plan-btn-w" v-else>
                     <a class="btn btn-primary btn-rounded" href="#" @click="buyPremium('Premium+', 'dana')">QR Payment</a>&nbsp;
                   </div>
                 </div>
                 <div class="plan-description">
                   <h6>
                     Features
                   </h6>
                   <ul>
                     <li>
                       Join full servers
                     </li>
                     <li>
                       <b>Access to !replace command (on Arena, Retakes & PUG servers)</b>
                     </li>
                     <li>
                       <b>No Arena Challenge cooldown</b>
                     </li>
                     <li>
                       <b>No Timelimit (on Deathmatch servers)</b>
                     </li>
                     <li>
                       <b>Double map vote (x2) @ PUG & RTV</b>
                     </li>
                     <li>
                       <b>Access to !mute command (block voice-disturbing players)</b>
                     </li>
                   </ul>
                 </div>
               </div>
               <div class="pricing-plan col-sm-4">
                 <div class="plan-head">
                   <div class="plan-image">
                     <img alt="" src="img/plan2.png">
                   </div>
                   <div class="plan-name">
                     Premium X
                   </div>
                 </div>
                 <div class="plan-body">
                   <div class="plan-price-w">
                     <div class="price-value" v-if="country === 'ID'">
                       Rp 30rb
                     </div>
                     <div class="price-value" v-else>
                       US$ 4
                     </div>
                     <div class="price-label" v-if="country === 'ID'">
                       per bulan
                     </div>
                     <div class="price-label" v-else>
                       per month
                     </div>
                   </div>
                   <div class="plan-btn-w" v-if="!this.$root.isAuthenticated">
                     <a class="btn btn-primary btn-rounded" href="https://api-staging.zero1.id/auth/steam">Login with Steam to Buy</a>&nbsp;
                   </div>
                   <div class="plan-btn-w" v-else>
                     <a class="btn btn-primary btn-rounded" href="#" @click="buyPremium('PremiumX', 'dana')">QR Payment</a>&nbsp;
                   </div>
                 </div>
                 <div class="plan-description">
                   <h6>
                     Features
                   </h6>
                   <ul>
                     <li>
                       Join full servers
                     </li>
                     <li>
                       <b>Access to !replace command (on Arena, Retakes & PUG servers)</b>
                     </li>
                     <li>
                       <b>No Arena Challenge cooldown</b>
                     </li>
                     <li>
                       <b>No Timelimit (on Deathmatch servers)</b>
                     </li>
                     <li>
                       <b>Double map vote (x2) @ PUG & RTV</b>
                     </li>
                     <li>
                       <b>Access to !mute command (block voice-disturbing players)</b>
                     </li>
                     <li>
                       <b>Access to !votekick command (T&C apply.)</b>
                     </li>
                     <li>
                       <b>Change weapons every round @ Retakes</b>
                     </li>
                     <li>
                       <b>Statistics reset (contact admin)</b>
                     </li>
                   </ul>
                 </div>
               </div>
             </div>
             <app-darkcolor></app-darkcolor>
             <app-invitation v-if="this.$root.authenticated"></app-invitation>
           </div>
         </div>
       </div>
     </div>
  </div>
</template>

<script>
import Navbar from './partials/Navbar.vue';
import Sidebar from './partials/Sidebar.vue';
import Alert from './partials/Alert';
import DarkColor from './partials/DarkColor';
import RightSidebar from './partials/RightSidebar';
import Invitation from './partials/Invitation';

export default {
  name: 'Premium',
  metaInfo: {
    title: 'premium',
    titleTemplate: 'zero1 by Dreamstart | %s',
    meta: [
      { property: 'og:title', content: 'zero1 by Dreamstart | premium' },
      { property: 'og:site_name', content: 'zero1' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://zero1.id/premium'},
      { property: 'og:description', content: 'Providing public & private CS:GO servers' },
      { itemprop: 'name', content: 'zero1 by Dreamstart | premium' },
      { itemprop: 'description', content: 'Providing public & private CS:GO servers'},
    ]
  },
  data() {
    return {
      welcomeText: 'Welcome to zero1!',
      servers: [],
      user_id: this.$root.userProfile.id,
      country: 'US'
    }
  },
  computed: {
    //
  },
  methods: {
    buyPremium(type, paymentMethod) {
      let email = prompt('Please enter your phone number. (08123456789)')
      if (email) {
        console.log(this.$root.authToken);
        this.axios.post(`${this.API_URL}/invoices/ocbc/create`, { user_id: this.$root.userProfile.id, email: email, type: type, paymentMethod: paymentMethod }, {
          headers: { 'Authorization': this.$root.authToken }
        }).then((res) => {
          if (paymentMethod === 'dana') {
            window.location.href = `${this.API_URL}/qr-pay/${res.data.id}`
          } else if (paymentMethod === 'midtrans') {
            snap.pay(res.data.snapToken)
          } else if (paymentMethod === 'doku') {
            window.location.href = `https://dashboard.zero1.id/invoices/doku/${res.data.id}`
          }
        }).catch(() => {
          alert("An error occured creating transaction. Please try again.")
        })
      }
    },
    detectMob() {
     if( navigator.userAgent.match(/Android/i)
     || navigator.userAgent.match(/webOS/i)
     || navigator.userAgent.match(/iPhone/i)
     || navigator.userAgent.match(/iPad/i)
     || navigator.userAgent.match(/iPod/i)
     || navigator.userAgent.match(/BlackBerry/i)
     || navigator.userAgent.match(/Windows Phone/i)
     ){
        return true;
      }
     else {
        return false;
      }
    }
  },
  created() {
    window.$('body').addClass('before-body menu-position-side menu-side-left full-screen with-content-panel');
    axios.get('https://api-onetap.serverdream.net/api/v3/location').then((res) => {
      this.country = res.data.countryCode;
    })
  },
  mounted() {
        if (this.$root.isAuthenticated) {
        }
  },
  components: {
    'app-navbar': Navbar,
    'app-sidebar': Sidebar,
    'app-alert': Alert,
    'app-rightsidebar': RightSidebar,
    'app-invitation': Invitation
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
